export const LearningCenterSections = {
  FAQ: 'faq',
  ESG_FUNDAMENTALS: 'esg-fundamentals',
};
